module.exports = __webpack_public_path__ + "static/media/PDF_88.e2a90f84.pdf";